<script>
import { ManagingVesselService } from "@/services/ManagingVesselService";
import {AlertService} from "@/services/AlertService";
import AppLoading from "@/components/elements/AppLoading.vue";
export default {
  components: {AppLoading},
  data() {
    return {
      form: {
        year_event: "",
        total_number_vessel_average: '',
        kobe_total: '',
        stgt_ogd_total: '',
        stargate_bulgaria_total: '',
        stgt_eccd_total: '',
        rohq_total: '',
      },
      updateForm: {
        id: null,
        year_event: "",
        total_number_vessel_average: '',
        kobe_total: '',
        stgt_ogd_total: '',
        stargate_bulgaria_total: '',
        stgt_eccd_total: '',
        rohq_total: '',
      },
      originalRecord: null,
      errors: {},
      deleteId: null,
      deleteYear: null,
      years: [],
      vessels: [],
      loading: false,
      currentPage: 1,
      lastPage: 1,
      perPage: 10,
      password: '',
      paginationWindow: 10
    };
  },
  watch: {
    'form.year_event'(input) {
      if (this.errors.year_event) {
        this.$set(this.errors, 'year_event', "");
      }
    },
    'updateForm.year_event'(input) {
      if (this.errors.year_event) {
        this.$set(this.errors, 'year_event', null);
      }
    },
    'password'(input) {
      if (this.errors.password) {
        this.$set(this.errors, 'password', null);
      }
    }
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 1900; y--) {
      this.years.push(y);
    }
    this.fetchVessels();
  },
  computed: {
    hasUpdateChanges() {
      if (!this.originalRecord) return false;
      const fields = [
        'year_event',
        'total_number_vessel_average',
        'kobe_total',
        'stgt_ogd_total',
        'stargate_bulgaria_total',
        'stgt_eccd_total',
        'rohq_total'
      ];
      return fields.some(field => String(this.updateForm[field] || '') !== String(this.originalRecord[field] || ''));
    },
    paginatedPages() {
      const pages = [];
      let start = Math.max(1, this.currentPage - Math.floor(this.paginationWindow / 2));
      let end = start + this.paginationWindow - 1;
      if (end > this.lastPage) {
        end = this.lastPage;
        start = Math.max(1, end - this.paginationWindow + 1);
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    async fetchVessels(page = 1) {
      this.loading = true;
      this.errors = {};
      const response = await ManagingVesselService.getAllManagingVessel(page, this.perPage);
      if (response) {
        this.vessels = response.data;
        this.currentPage = response.current_page;
        this.lastPage = response.last_page;
      } else {
        AlertService.errorAlert('Failed to fetch managing vessels', 'MANAGING VESSEL FETCH');
      }
      this.loading = false;
    },
    async handleCreate() {
      this.loading = true;
      this.errors = {};
      const payload = {
        year_event: Number(this.form.year_event),
        total_number_vessel_average: String(this.form.total_number_vessel_average || ''),
        kobe_total: String(this.form.kobe_total || ''),
        stgt_ogd_total: String(this.form.stgt_ogd_total || ''),
        stargate_bulgaria_total: String(this.form.stargate_bulgaria_total || ''),
        stgt_eccd_total: String(this.form.stgt_eccd_total || ''),
        rohq_total: String(this.form.rohq_total || ''),
      };

      const response = await ManagingVesselService.storeManagingVessel(payload);

      if (response && !response.error) {
        AlertService.successAlert('Record created successfully', 'MANAGING VESSEL CREATE', 2000);
        this.resetForm();
        this.fetchVessels();
        $('#createModal').modal('hide');
      } else {
        if (response && response.data && response.data.errors) {
          this.errors = response.data.errors;
        } else {
          AlertService.errorAlert('Failed to create record', 'MANAGING VESSEL CREATE');
        }
      }

      this.loading = false;
    },
    resetForm() {
      this.form = {
        year_event: "",
        total_number_vessel_average: '',
        kobe_total: '',
        stgt_ogd_total: '',
        stargate_bulgaria_total: '',
        stgt_eccd_total: '',
        rohq_total: '',
      };
      this.errors = {};
    },
    openCreateModal () {
      this.resetForm()
      $('#createModal').modal('show');
    },
    openUpdateModal(record) {
      this.errors = {};
      this.originalRecord = { ...record };
      this.updateForm = {
        ...record,
        total_number_vessel_average: String(record.total_number_vessel_average || ''),
        kobe_total: String(record.kobe_total || ''),
        stgt_ogd_total: String(record.stgt_ogd_total || ''),
        stargate_bulgaria_total: String(record.stargate_bulgaria_total || ''),
        stgt_eccd_total: String(record.stgt_eccd_total || ''),
        rohq_total: String(record.rohq_total || ''),
      };
      $('#updateModal').modal('show');
    },
    async handleUpdate() {
      this.loading = true;
      this.errors = {};
      const payload = {
        year_event: Number(this.updateForm.year_event),
        total_number_vessel_average: String(this.updateForm.total_number_vessel_average || ''),
        kobe_total: String(this.updateForm.kobe_total || ''),
        stgt_ogd_total: String(this.updateForm.stgt_ogd_total || ''),
        stargate_bulgaria_total: String(this.updateForm.stargate_bulgaria_total || ''),
        stgt_eccd_total: String(this.updateForm.stgt_eccd_total || ''),
        rohq_total: String(this.updateForm.rohq_total || ''),
      };
      const response = await ManagingVesselService.updateManagingVessel(this.updateForm.id, payload);
      if (response && !response.error) {
        AlertService.successAlert('Record updated successfully', 'MANAGING VESSEL UPDATE', 2000);
        this.fetchVessels(this.currentPage);
        $('#updateModal').modal('hide');
      } else {
        if (response && response.data && response.data.errors) {
          this.errors = response.data.errors;
        } else {
          AlertService.successAlert('Failed to update record', 'MANAGING VESSEL UPDATE');
        }
      }
      this.loading = false;
    },
    openDeleteModal(vessel) {
      this.errors = {};
      this.deleteId = vessel.id;
      this.deleteYear = vessel.year_event;
      this.password = '';
      $('#deleteModal').modal('show');
    },
    async handleDelete() {
      this.loading = true;
      this.errors = {};
      const response = await ManagingVesselService.destroyManagingVessel(this.deleteId, this.password);
      if (response && !response.error) {
        AlertService.successAlert('Record deleted successfully', 'MANAGING VESSEL DELETE', 2000);
        this.fetchVessels(this.currentPage);
        $('#deleteModal').modal('hide');
      } else {
        if (response && response.data && response.data.errors) {
          this.errors = response.data.errors;
        } else {
          AlertService.errorAlert('Failed to delete record', 'MANAGING VESSEL DELETE');
        }
      }
      this.loading = false;
    },
    goToPage(page) {
      if (page >= 1 && page <= this.lastPage) {
        this.fetchVessels(page);
        this.errors = {};
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="row align-items-center mb-2">
      <div class="col-sm-6">
        <h3 class="text-left">Average Number of Managing Vessel</h3>
      </div>
    </div>

    <div class="row align-items-center mb-3">
      <div class="col-sm-6">
        <nav aria-label="Page navigation">
          <ul class="pagination justify-content-start mb-0">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button class="page-link" @click="goToPage(1)">First</button>
            </li>
            <li class="page-item" v-for="page in paginatedPages" :key="page" :class="{ active: page === currentPage }">
              <button class="page-link" @click="goToPage(page)">{{ page }}</button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === lastPage }">
              <button class="page-link" @click="goToPage(lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-sm-6 text-right">
        <button class="e-btn e-btn-green e-text-white pr-3" @click="openCreateModal()">
          <font-awesome-icon icon="plus-square" style="width: 25px"/>
          <small class="font-weight-bold">NEW RECORD</small>
        </button>
      </div>
    </div>

    <div class="col-12 pl-0 text-center col-lg-12">
      <div class="row no-gutters">
        <table class="table table-sm table-bordered small mt-2">
          <thead>
          <tr>
            <th class="text-center">#</th>
            <th class="text-center">Year Event</th>
            <th class="text-center">Total Number Vessel Average</th>
            <th class="text-center">Kobe</th>
            <th class="text-center">STGT OGD</th>
            <th class="text-center">Stargate Bulgaria</th>
            <th class="text-center">STGT ECCD</th>
            <th class="text-center">ROHQ</th>
            <th class="text-center">ACTION</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>
          <tr v-else-if="vessels.length === 0">
            <td colspan="9" class="text-center">No records found</td>
          </tr>
          <tr v-else v-for="(vessel, index) in vessels" :key="vessel.id">
            <td class="align-middle font-weight-bold">{{ index + 1 + (currentPage - 1) * perPage }}</td>
            <td class="align-middle">{{ vessel.year_event }}</td>
            <td class="align-middle">{{ vessel.total_number_vessel_average }}</td>
            <td class="align-middle">{{ vessel.kobe_total }}</td>
            <td class="align-middle">{{ vessel.stgt_ogd_total }}</td>
            <td class="align-middle">{{ vessel.stargate_bulgaria_total }}</td>
            <td class="align-middle">{{ vessel.stgt_eccd_total }}</td>
            <td class="align-middle">{{ vessel.rohq_total }}</td>
            <td class="align-middle">
              <div class="btn-group dropleft">
                <button class="mr-2 btn btn-sm btn-secondary force-white-all" data-toggle="dropdown">
                  <font-awesome-icon icon="cogs"/>
                </button>
                <div class="dropdown-menu">
                  <button class="dropdown-item text-secondary font-weight-bolder" @click="openUpdateModal(vessel)">
                    <font-awesome-icon icon="pen"/> Edit
                  </button>
                  <button class="dropdown-item text-secondary font-weight-bolder text-danger" @click="openDeleteModal(vessel)">
                    <font-awesome-icon icon="trash" class="force-danger-all"/> Delete
                  </button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="createModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form @submit.prevent="handleCreate">
            <div class="modal-header">
              <h5 class="modal-title" id="createModalLabel" style="font-weight: bold;">CREATE RECORD</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Year Event</label>
                <select class="form-control" v-model="form.year_event" required>
                  <option value='' disabled selected>-- SELECT YEAR --</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
                <small v-if="errors.year_event" class="text-danger">
                  {{ errors.year_event[0] }}
                </small>
              </div>
              <div class="form-group"><label>Total Number Vessel Average</label><input type="number" step="any" class="form-control" v-model.number="form.total_number_vessel_average"></div>
              <div class="form-group"><label>Kobe Total</label><input type="number" step="any" class="form-control" v-model.number="form.kobe_total"></div>
              <div class="form-group"><label>STGT OGD Total</label><input type="number" step="any" class="form-control" v-model.number="form.stgt_ogd_total"></div>
              <div class="form-group"><label>Stargate Bulgaria Total</label><input type="number" step="any" class="form-control" v-model.number="form.stargate_bulgaria_total"></div>
              <div class="form-group"><label>STGT ECCD Total</label><input type="number" step="any" class="form-control" v-model.number="form.stgt_eccd_total"></div>
              <div class="form-group"><label>ROHQ Total</label><input type="number" step="any" class="form-control" v-model.number="form.rohq_total"></div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Create</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade" id="updateModal" tabindex="-1" role="dialog" aria-labelledby="updateModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form @submit.prevent="handleUpdate">
            <div class="modal-header">
              <h5 class="modal-title" style="font-weight: bold;">UPDATE RECORD</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Year Event</label>
                <select class="form-control" v-model="updateForm.year_event" required>
                  <option value='' disabled selected>-- SELECT YEAR --</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
                <small v-if="errors.year_event" class="text-danger">
                  {{ errors.year_event[0] }}
                </small>
              </div>
              <div class="form-group"><label>Total Number Vessel Average</label><input type="number" step="any" class="form-control" v-model.number="updateForm.total_number_vessel_average"></div>
              <div class="form-group"><label>Kobe Total</label><input type="number" step="any" class="form-control" v-model.number="updateForm.kobe_total"></div>
              <div class="form-group"><label>STGT OGD Total</label><input type="number" step="any" class="form-control" v-model.number="updateForm.stgt_ogd_total"></div>
              <div class="form-group"><label>Stargate Bulgaria Total</label><input type="number" step="any" class="form-control" v-model.number="updateForm.stargate_bulgaria_total"></div>
              <div class="form-group"><label>STGT ECCD Total</label><input type="number" step="any" class="form-control" v-model.number="updateForm.stgt_eccd_total"></div>
              <div class="form-group"><label>ROHQ Total</label><input type="number" step="any" class="form-control" v-model.number="updateForm.rohq_total"></div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary" :disabled="!hasUpdateChanges">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <form @submit.prevent="handleDelete">
            <div class="modal-header">
              <h5 class="modal-title" style="font-weight: bold;">DELETE RECORD</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Are you sure you want to delete the record of the year <span style="font-weight: bold;">{{ deleteYear }}</span>?</label>
                <input type="password" class="form-control" v-model="password" placeholder="Enter password" required>
                <small v-if="errors.password" class="text-danger">
                  {{ errors.password[0] }}
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-danger">Delete</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
